<template>
  <div class="content">
    <div class="thehome">{{ $t("header.home") }} &nbsp;/</div>
    <div class="require">
      (<span style="color: #ed7e64">*</span>)&nbsp;{{
        $t("header.This_field_is_required")
      }}
    </div>
    <div class="inputcontent">
      <div class="one">
        {{ $t("header.Shanghai_ACM_SIGGRAPH_chapter_membership_table") }}
      </div>
      <div class="member_table">
        <div class="inputtype">{{ $t("header.Personal_information") }}</div>
        <div class="row ">
          <div class="flex toright tobottom">
            <div class="tothetitle">
              {{ $t("header.name") }}<span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.name"
                :placeholder="$t('header.name')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <div class="tothetitle">{{ $t('header.gender') }}<span class="required-star">*</span></div>
            <div class="input">
              <el-select v-model="state.gender" :placeholder="$t('header.gender')" style="width: 100%">
                <el-option :label="$t('header.gender_male')" value="1" />
                <el-option :label="$t('header.gender_female')" value="2" />
                <el-option :label="$t('header.gender_other')" value="0" />
              </el-select>
            </div>
          </div>
        </div>
        <div class="row toright">
          <div class="flex toright tobottom">
            <div class="tothetitle">
              {{ $t('header.organization') }}<span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.Organization"
                :placeholder="$t('header.organization')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <div class="tothetitle">
              {{ $t('header.position') }}<span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.Position"
                :placeholder="$t('header.position')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="flex toright tobottom">
            <div class="tothetitle">
              {{ $t('header.nationality') }}<span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.nationality"
                :placeholder="$t('header.nationality')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex"></div>
        </div>
        <div class="inputtype">
          {{ $t("header.Address_information") }}
          <span class="required-star">*</span>
        </div>
        <div class="row toright">
          <div class="flex toright ">
            <div class="tothetitle">
              {{ $t("header.nation") }}
              <span class="required-star">*</span>
            </div>
            <div class="input">
              <el-select
                v-model="state.nation"
                :placeholder="$t('header.nation')"
                filterable
                style="width: 100%"
                @change="() => { state.province = ''; state.city = ''; }"
              >
                <el-option label="China" value="China" />
                <el-option label="Afghanistan" value="Afghanistan" />
                <el-option label="Albania" value="Albania" />
                <el-option label="Algeria" value="Algeria" />
                <el-option label="Argentina" value="Argentina" />
                <el-option label="Armenia" value="Armenia" />
                <el-option label="Australia" value="Australia" />
                <el-option label="Austria" value="Austria" />
                <el-option label="Azerbaijan" value="Azerbaijan" />
                <el-option label="Bahrain" value="Bahrain" />
                <el-option label="Bangladesh" value="Bangladesh" />
                <el-option label="Belarus" value="Belarus" />
                <el-option label="Belgium" value="Belgium" />
                <el-option label="Bolivia" value="Bolivia" />
                <el-option label="Bosnia and Herzegovina" value="Bosnia and Herzegovina" />
                <el-option label="Brazil" value="Brazil" />
                <el-option label="Bulgaria" value="Bulgaria" />
                <el-option label="Cambodia" value="Cambodia" />
                <el-option label="Cameroon" value="Cameroon" />
                <el-option label="Canada" value="Canada" />
                <el-option label="Chile" value="Chile" />
                <el-option label="Colombia" value="Colombia" />
                <el-option label="Croatia" value="Croatia" />
                <el-option label="Cuba" value="Cuba" />
                <el-option label="Czech Republic" value="Czech Republic" />
                <el-option label="Denmark" value="Denmark" />
                <el-option label="Ecuador" value="Ecuador" />
                <el-option label="Egypt" value="Egypt" />
                <el-option label="Ethiopia" value="Ethiopia" />
                <el-option label="Finland" value="Finland" />
                <el-option label="France" value="France" />
                <el-option label="Georgia" value="Georgia" />
                <el-option label="Germany" value="Germany" />
                <el-option label="Ghana" value="Ghana" />
                <el-option label="Greece" value="Greece" />
                <el-option label="Hong Kong" value="Hong Kong" />
                <el-option label="Hungary" value="Hungary" />
                <el-option label="India" value="India" />
                <el-option label="Indonesia" value="Indonesia" />
                <el-option label="Iran" value="Iran" />
                <el-option label="Iraq" value="Iraq" />
                <el-option label="Ireland" value="Ireland" />
                <el-option label="Israel" value="Israel" />
                <el-option label="Italy" value="Italy" />
                <el-option label="Japan" value="Japan" />
                <el-option label="Jordan" value="Jordan" />
                <el-option label="Kazakhstan" value="Kazakhstan" />
                <el-option label="Kenya" value="Kenya" />
                <el-option label="Kuwait" value="Kuwait" />
                <el-option label="Laos" value="Laos" />
                <el-option label="Latvia" value="Latvia" />
                <el-option label="Lebanon" value="Lebanon" />
                <el-option label="Libya" value="Libya" />
                <el-option label="Lithuania" value="Lithuania" />
                <el-option label="Luxembourg" value="Luxembourg" />
                <el-option label="Macau" value="Macau" />
                <el-option label="Malaysia" value="Malaysia" />
                <el-option label="Mexico" value="Mexico" />
                <el-option label="Mongolia" value="Mongolia" />
                <el-option label="Morocco" value="Morocco" />
                <el-option label="Myanmar" value="Myanmar" />
                <el-option label="Nepal" value="Nepal" />
                <el-option label="Netherlands" value="Netherlands" />
                <el-option label="New Zealand" value="New Zealand" />
                <el-option label="Nigeria" value="Nigeria" />
                <el-option label="North Korea" value="North Korea" />
                <el-option label="Norway" value="Norway" />
                <el-option label="Pakistan" value="Pakistan" />
                <el-option label="Peru" value="Peru" />
                <el-option label="Philippines" value="Philippines" />
                <el-option label="Poland" value="Poland" />
                <el-option label="Portugal" value="Portugal" />
                <el-option label="Qatar" value="Qatar" />
                <el-option label="Romania" value="Romania" />
                <el-option label="Russia" value="Russia" />
                <el-option label="Saudi Arabia" value="Saudi Arabia" />
                <el-option label="Serbia" value="Serbia" />
                <el-option label="Singapore" value="Singapore" />
                <el-option label="Slovakia" value="Slovakia" />
                <el-option label="Slovenia" value="Slovenia" />
                <el-option label="South Africa" value="South Africa" />
                <el-option label="South Korea" value="South Korea" />
                <el-option label="Spain" value="Spain" />
                <el-option label="Sri Lanka" value="Sri Lanka" />
                <el-option label="Sweden" value="Sweden" />
                <el-option label="Switzerland" value="Switzerland" />
                <el-option label="Syria" value="Syria" />
                <el-option label="Taiwan" value="Taiwan" />
                <el-option label="Thailand" value="Thailand" />
                <el-option label="Tunisia" value="Tunisia" />
                <el-option label="Turkey" value="Turkey" />
                <el-option label="Ukraine" value="Ukraine" />
                <el-option label="United Arab Emirates" value="United Arab Emirates" />
                <el-option label="United Kingdom" value="United Kingdom" />
                <el-option label="United States" value="United States" />
                <el-option label="Uzbekistan" value="Uzbekistan" />
                <el-option label="Venezuela" value="Venezuela" />
                <el-option label="Vietnam" value="Vietnam" />
                <el-option label="Other" value="Other" />
              </el-select>
            </div>
          </div>
          <div class="flex" v-if="state.nation === 'China'">
            <div class="tothetitle">
              {{ $t("header.province") }}
              <span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.province"
                :placeholder="$t('header.province')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex" v-else></div>
        </div>
        <div class="row">
          <div class="flex toright tobottom" v-if="state.nation === 'China'">
            <div class="tothetitle">
              {{ $t("header.city") }}
              <span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.city"
                :placeholder="$t('header.city')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <div class="tothetitle">
              {{ $t("header.Postal_code") }}
              <span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.postal"
                :placeholder="$t('header.Postal_code')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="flex">
            <div class="tothetitle">
              {{ $t("header.street") }}
              <span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.street"
                :placeholder="$t('header.street')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="inputtype">
          {{ $t("header.Contact_information") }}
          <span class="required-star">*</span>
        </div>
        <div class="row">
          <div class="flex toright phone-input">
            <div class="tothetitle">
              {{ $t("header.telephone") }}
              <span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.phone"
                :placeholder="$t('header.telephone')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- email + code row -->
        <div class="row email-row">
          <div class="flex toright tobottom email-left">
            <div class="tothetitle">
              {{ $t("header.email") }}
              <span class="required-star">*</span>
            </div>
            <div class="input email-input">
              <el-input
                v-model="state.mailbox"
                :placeholder="$t('header.email')"
                type="email"
                @input="email"
                :class="state.emailerror && 'error'"
              ></el-input>
              <button
                class="send-code-btn"
                type="button"
                :disabled="state.isSendingCode || !state.mailbox"
                @click="sendEmailCode"
              >
                {{ state.codeCountdown > 0 ? `${state.codeCountdown}s` : state.isSendingCode ? $t('header.sending_code') : state.codeSent ? $t('header.resend_code') : $t('header.send_code') }}
              </button>
              <div
                v-if="state.emailerror"
                class="email-error"
              >
                {{ $t('header.email_error') }}
              </div>
            </div>
          </div>
          <div class="flex code-input">
            <div class="tothetitle">
              {{ $t('header.verification_code') }}
              <span class="required-star">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.emailCode"
                :placeholder="$t('header.verification_code')"
                type="text"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- <div class="hint">
          如果您过去是ACM的会员,或者拥有ACM账户,请输入改电子邮件地址,以使此会员资格与该记录保持一致
        </div> -->
        <div class="inputtype academic-background-title">
          {{ $t('header.academic_background') }}
          <span class="optional-note">{{ $t('header.academic_optional') }}</span>
        </div>
        <div class="row">
          <div class="flex">
            <div class="tothetitle">{{ $t('header.has_paper') }}</div>
            <div class="input">
              <el-radio-group v-model="state.hasPaper">
                <el-radio label="no">{{ $t('header.paper_no') }}</el-radio>
                <el-radio label="yes">{{ $t('header.paper_yes') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <template v-if="state.hasPaper === 'yes'">
          <div class="row">
            <div class="flex">
              <div class="tothetitle">{{ $t('header.paper_authors') }}</div>
              <div class="input">
                <el-input
                  v-model="state.paperAuthors"
                  :placeholder="$t('header.paper_authors')"
                  type="text"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex">
              <div class="tothetitle">{{ $t('header.paper_title') }}</div>
              <div class="input">
                <el-input
                  v-model="state.paperTitle"
                  :placeholder="$t('header.paper_title')"
                  type="text"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex toright tobottom">
              <div class="tothetitle">{{ $t('header.paper_venue') }}</div>
              <div class="input">
                <el-input
                  v-model="state.paperVenue"
                  :placeholder="$t('header.paper_venue')"
                  type="text"
                ></el-input>
              </div>
            </div>
            <div class="flex">
              <div class="tothetitle">{{ $t('header.paper_year') }}</div>
              <div class="input">
                <el-input
                  v-model="state.paperYear"
                  :placeholder="$t('header.paper_year')"
                  type="text"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="flex">
              <div class="tothetitle">{{ $t('header.paper_doi') }}</div>
              <div class="input">
                <el-input
                  v-model="state.paperLink"
                  :placeholder="$t('header.paper_doi')"
                  type="text"
                ></el-input>
              </div>
            </div>
          </div>
        </template>
        <div class="inputtype">
          {{ $t("header.Membership_type") }}
          <span class="required-star">*</span>
        </div>
        <div class="row">
          <el-radio-group v-model="state.radio1" class="ml-4">
            <el-radio class="right-80" label="1" size="large">{{
              $t("header.Professional")
            }}</el-radio>
            <el-radio class="" label="2" size="large">{{
              $t("header.Student")
            }}</el-radio>
          </el-radio-group>
        </div>
        <div class="inputtype">
          {{ $t("header.Membership_survey") }}
          <span class="required-star">*</span>
        </div>
        <div class="row">
          <div class="selection">{{ $t("header.Main_job_functions") }}</div>
          <div style="flex: 1">
            <el-checkbox-group v-model="state.checkList">
              <div class="check">
                <el-checkbox :label="$t('header.architect')" />
                <el-checkbox :label="$t('header.artist')" />
                <el-checkbox :label="$t('header.educator')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.engineer')" />
                <el-checkbox :label="$t('header.Film_Producer')" />
                <el-checkbox :label="$t('header.Game_developers')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Graphic_design')" />
                <el-checkbox :label="$t('header.Manager_Executive')" />
                <el-checkbox :label="$t('header.Musician')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Product_Design')" />
                <el-checkbox
                  :label="$t('header.Research_Institute/Scientist')"
                />
                <el-checkbox
                  :label="$t('header.Software_Developer/Programmer')"
                />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Student')" />
                <el-checkbox :label="$t('header.Tech_Artist')" />
                <el-checkbox :label="$t('header.Photographer_Video_Editor')" />
              </div>
              <div class="check">
                <el-checkbox
                  :label="$t('header.Network_developers/e-commerce')"
                />
                <el-checkbox :label="$t('header.other')" />
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="row">
          <div class="selection">{{ $t("header.Areas_of_interest") }}</div>
          <div style="flex: 1">
            <el-checkbox-group v-model="state.checkList2">
              <div class="check">
                <el-checkbox :label="$t('header.animation')" />
                <el-checkbox :label="$t('header.artificial_intelligence')" />
                <el-checkbox :label="$t('header.Broadcast/Dynamic_Design')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.CAD/CAM/CAE')" />
                <el-checkbox
                  :label="$t('header.Digital_Photography/Digital_Imaging')"
                />
                <el-checkbox :label="$t('header.education')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Emerging_technologies')" />
                <el-checkbox :label="$t('header.Movies/Videos')" />
                <el-checkbox
                  :label="$t('header.Art/Performance/Installation')"
                />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Games/Game_Development')" />
                <el-checkbox
                  :label="$t('header.Illustration/Graphic_Design')"
                />
                <el-checkbox :label="$t('header.image_processing')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Interactive_technology')" />
                <el-checkbox :label="$t('header.Internet/Telecom')" />
                <el-checkbox :label="$t('header.multimedia')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Music/Audio')" />
                <el-checkbox :label="$t('header.Physical_calculations')" />
                <el-checkbox :label="$t('header.pipeline')" />
              </div>
              <div class="check">
                <el-checkbox
                  :label="$t('header.Programming/Software_Development')"
                />
                <el-checkbox :label="$t('header.Scientific_Visualization')" />
                <el-checkbox :label="$t('header.Special_effects/synthesis')" />
              </div>
              <div class="check">
                <el-checkbox :label="$t('header.Virtual/Augmented_Reality')" />
                <el-checkbox :label="$t('header.Web_Design')" />
                <el-checkbox :label="$t('header.other')" />
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div
          class="submit"
          @click="submit"
          :class="
            state.name &&
            state.nation &&
            (state.nation !== 'China' || (state.province && state.city)) &&
            state.postal &&
            state.street &&
            state.phone &&
            state.mailbox &&
            state.radio1 &&
            state.checkList.length &&
            state.checkList2.length &&
            state.Organization &&
            state.Position &&
            'click'
          "
        >
          <div class="tj">{{ $t("header.submit") }}</div>
          <div>
            <img
              src="https://bunseninstitutes.oss-cn-hangzhou.aliyuncs.com/files/images/join_icon_arrow.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElNotification } from "element-plus";
import { submit_form, send_email_code } from "@/api/type.js";
import { reactive, computed, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
const router = useRouter();
const { locale, t } = useI18n();
const state = reactive({
  name: "",
  gender: "",
  contact: "",
  nation: "",
  province: "",
  Organization: "",
  Position: "",
  nationality: "",
  city: "",
  postal: "",
  street: "",
  phone: "",
  mailbox: "",
  checkList: [],
  checkList2: [],
  radio1: false,
  emailerror: false,
  emailCode: "",
  isSendingCode: false,
  codeCountdown: 0,
  codeButtonText: "",
  codeSent: false,
});
// 决定提交方法是否执行及动态样式
// ref: sub = computed(() => {
//   if (
//     state.name &&
//     state.nation &&
//     state.province &&
//     state.city &&
//     state.postal &&
//     state.street &&
//     state.phone &&
//     state.mailbox &&
//     state.radio1 &&
//     state.checkList &&
//     state.checkList2 &&
//     !state.emailerror &&
//     state.Organization &&
//     state.Position &&
//     state.emailCode
//   ) {
//     return true;
//   } else {
//     return false;
//   }
// });
// ref : sub = 1
// 提交分会会员表单的权限
let emailCodeTimer = null;
const email = (e) => {
  const emailPattern = /^[\w\.-]+@[\w\.-]+\.\w+$/;
  if (emailPattern.test(e)) {
    state.emailerror = false;
  } else {
    state.emailerror = true;
  }
};

const resetCodeTimer = () => {
  if (emailCodeTimer) {
    clearInterval(emailCodeTimer);
    emailCodeTimer = null;
  }
};

const startCodeCountdown = () => {
  resetCodeTimer();
  state.codeCountdown = 60;
  state.isSendingCode = true;
  emailCodeTimer = setInterval(() => {
    state.codeCountdown -= 1;
    if (state.codeCountdown <= 0) {
      state.isSendingCode = false;
      resetCodeTimer();
    } else {
      state.codeCountdown = state.codeCountdown;
    }
  }, 1000);
};

onBeforeUnmount(() => {
  resetCodeTimer();
});

const sendEmailCode = async () => {
  if (state.isSendingCode || !state.mailbox) return;
  if (state.emailerror) {
    ElNotification({
      title: (locale.value == "zh" && "失败") || "Error",
      message:
        (locale.value == "zh" && "邮箱格式不正确") || "Invalid email",
      type: "error",
    });
    return;
  }
  try {
    state.isSendingCode = true;
    state.codeButtonText = "发送中...";
    const res = await send_email_code({ email: state.mailbox });

    // 后端会返回 success + message，根据 success 决定提示内容
    if (!res || res.success === false) {
      state.isSendingCode = false;
      state.codeSent = true;
      ElNotification({
        title: (locale.value == "zh" && "失败") || "Error",
        message: res && res.message ? res.message : ((locale.value == "zh" && "验证码发送失败") || "Failed to send code"),
        type: "error",
      });
      return;
    }

    // success === true
    ElNotification({
      title: (locale.value == "zh" && "成功") || "Success",
      message: (res && res.message) || ((locale.value == "zh" && "验证码已发送") || "Code has been sent"),
      type: "success",
    });
    startCodeCountdown();
    state.codeSent = true;
  } catch (error) {
    state.isSendingCode = false;
    state.codeSent = true;
    ElNotification({
      title: (locale.value == "zh" && "失败") || "Error",
      message:
        (locale.value == "zh" && "验证码发送失败") || "Failed to send code",
      type: "error",
    });
  }
};
const submit = async () => {
  if (
    state.name &&
    state.nation &&
    (state.nation !== 'China' || (state.province && state.city)) &&
    state.postal &&
    state.street &&
    state.phone &&
    state.mailbox &&
    state.radio1 &&
    state.checkList.length &&
    state.checkList2.length &&
    !state.emailerror &&
    state.Organization &&
    state.Position &&
    state.emailCode
  ) {
    // console.log(state.radio1, 98989);
    const academicBackground =
      state.hasPaper === "yes"
        ? [
            {
              authors: state.paperAuthors,
              paper_title: state.paperTitle,
              conference: state.paperVenue,
              year: state.paperYear,
              doi_link: state.paperLink,
            },
          ]
        : [];
    try {
      const data = await submit_form({
        username: state.name,
        country: state.nation,
        province: state.province,
        city: state.city,
        street: state.street,
        phone: state.phone,
        work_unit: state.Organization,
        job_position: state.Position,
        postal_code: state.postal,
        email: state.mailbox,
        member_type: state.radio1,
        main_job_functions: state.checkList,
        areas_of_interest: state.checkList2,
        academic_background: academicBackground,
        verification_code: state.emailCode,
        country_code: state.nationality,
        gender: state.gender,
      });
      // 只有 success===true 且 message 为“表单提交成功”时才视为真正成功
      if (data && data.success && data.message === "表单提交成功") {
        ElNotification({
          title: (locale.value == "zh" && "成功") || "success",
          message:
            (locale.value == "zh" && "分会会员表填写成功!正在为您跳转到首页") ||
            "Chapter membership form completed successfully! Going to the home page for you",
          type: "success",
        });
        // 如需自动跳转，可开启下面代码
        setTimeout(() => {
          router.push("/");
        }, 1000);
      } else if (data) {
        // 其余情况统一按失败处理，展示后端返回的 message
        ElNotification({
          title: (locale.value == "zh" && "失败") || "Error",
          message:
            data.message ||
            ((locale.value == "zh" && "提交失败，请检查表单信息") ||
              "Submit failed, please check the form"),
          type: "error",
        });
      }
    } catch (error) {
      // 捕获网络错误或其它未预期异常
      ElNotification({
        title: (locale.value == "zh" && "失败") || "Error",
        message:
          (error && error.data && error.data.message) ||
          error?.data.message ||
          ((locale.value == "zh" && "提交失败，请稍后重试") ||
            "Submit failed, please try again later"),
        type: "error",
      });
      console.error("submit_form error", error);
    }
  }
};
</script>
<style lang="scss">
.el-input__wrapper {
  height: 64px;
  box-sizing: border-box;
  padding: 20px 20px !important;
  border: 2px solid #777777 !important;
  border-radius: 8px !important;
  background-color: #d8ddf9;
}
.error {
  .el-input__wrapper {
    border: 2px solid #d43327 !important;
  }
}
.el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #333333;
  background: #d8ddf9;
}
@media screen and (max-width: 600px) {
  .check {
    .el-checkbox {
      width: 100%;
      .el-checkbox__label {
        font-size: 14px;
      }
    }
  }
}
.el-checkbox {
  width: 30.3%;
}
.el-checkbox__label {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  width: 33.3%;
  text-align: left;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #000;
  background: #4a53d7;
}
.el-checkbox__inner::after {
  display: none;
  left: 8px !important;
  top: 5px !important;
}
.el-radio-group {
  width: 100%;
  color: #000;
  background: #d8ddf9;
  .el-radio {
    color: #000;
    font-size: 26px !important;
    font-weight: 800;

    .el-radio__inner {
      width: 20px;
      height: 20px;
      border: 2px solid #000;
      background: #d9ddf9;

      &::after {
        width: 10px;
        height: 10px;
        background-color: #000;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  position: relative;
  .thehome {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    // height: 500px;
    position: relative;
    padding: 68px 0 0 0;
    text-align: left;
    margin-bottom: 80px;
  }
  .require {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    text-align: right;
    @include fontstyle(#333, 16px, 800, auto);
    margin-bottom: 16px;
  }
  .inputcontent {
    background: #d7ddfa;
    padding: 82px 84px 0px 84px;
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .one {
    text-align: center;
    display: inline-block;
    @include fontstyle(#333, 40px, 800, auto);
    line-height: 47px;
    margin-bottom: 48px;
    // border-bottom: 8px solid #f4775e;
    // padding-bottom: 3px;
  }
  .member_table {
    max-width: 1176px;
    margin: 0 auto 56px;
    display: flex;
    flex-direction: column;
    .inputtype {
      @include fontstyle(#3657db, 22px, 800, auto);
      text-align: left;
      margin-bottom: 24px;
    }

    .submit {
      width: 232px;
      height: 106px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      :nth-child(2) {
        position: absolute;
        transition: all 0.5s;
        margin-bottom: 0px;
        left: 78px;
        opacity: 0;
        img {
          width: auto !important;
        }
      }
      &:hover {
        :nth-child(2) {
          left: 160px;
          opacity: 1;
        }
      }

      @include fontstyle(#fff, 20px, 800, auto);
      cursor: no-drop;
      line-height: 106px;
      position: relative;
      background: #ccc;
      right: -82px;
      align-self: flex-end;
      .tj {
        display: flex;
        align-items: center;
        justify-content: center;

        // &::after {
        //   content: url(https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/join_icon_arrow.svg);
        //   // display: block;
        //   margin-left: 20px;
        //   // position: absolute;
        //   // top: -9%;
        //   // right: 50%;
        //   // transform: translate(50%, 50%);
        // }
      }
    }
    .click {
      background: #3657db;
      cursor: pointer;
    }
    .row {
      display: flex;
      margin-bottom: 40px;
      align-items: center;
      .check {
        width: 100%;
        display: flex;
        margin-bottom: 25px;
        justify-content: normal;
      }
      .selection {
        @include fontstyle(#333, 16px, 800, auto);
        align-self: baseline;
        margin-top: 10px;
        margin-right: 72px;
      }
      .radiolist {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      // width: 100%;
      // justify-content: space-between;

      .flex {
        flex: 1;
        text-align: left;
        .hint {
          text-align: left;
          color: #666;
          margin-top: 10px;
          line-height: 20px;
          margin-bottom: 20px;
        }
      }
      .phone-input {
        flex: 0 0 48%;
      }
      .email-row {
        gap: 32px;
        align-items: flex-start;
      }
      .email-left,
      .code-input {
        flex: 1;
      }
      .email-input {
        position: relative;
      }
      .email-input .el-input__wrapper {
        padding-right: 90px !important; // 给按钮留出但不溢出的空间
        overflow: hidden;
      }
      .email-input .send-code-btn {
        position: absolute;
        top: 0; // 与输入框顶端对齐，避免随容器高度变化
        right: 0;
        transform: none;
        height: 64px; // 与 .el-input__wrapper 一致
        line-height: 64px;
        box-sizing: border-box;
        padding: 0 16px;
        border: 2px solid #777777;
        border-left: none;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        background-color: #f4775e;
        color: #333333;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
      }
      .email-input .send-code-btn:hover:not(:disabled) {
        background-color: #4a53d7;
        color: #ffffff;
      }
      .email-input .send-code-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
      .email-error {
        position: absolute;
        left: 0;
        top: 100%;
        margin-top: 5px;
        color: #d43327;
        font-weight: 800;
        white-space: nowrap;
      }
      .toright {
        margin-right: 40px;
      }
      .right-80 {
        margin-right: 100px;
      }
    }

    .tothetitle {
      font-size: 18px;
      font-weight: 800;
      text-align: left;
      margin-bottom: 12px;
    }
    .required-star {
      color: #d43327;
      margin-left: 4px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    padding: 30px;
  }
}
@media screen and (max-width: 1000px) {
  .row {
    display: flex;
    flex-direction: column;
    .flex {
      width: 100%;
    }
    .toright {
      margin-right: 0px !important;
    }
    .tobottom {
      margin-bottom: 40px;
    }
  }
}
@media screen and (max-width: 800px) {
  .inputcontent {
    padding: 82px 30px 0px 30px !important;
  }
  .submit {
    right: -30px !important;
  }
  .row {
    .selection {
      margin-bottom: 30px;
    }
    .el-checkbox-group {
      .check {
        flex-wrap: wrap;
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
